import { EuiHealth } from '@elastic/eui';
import React, { useEffect, useState } from 'react';
import SelectorSimple from '../../../../../shared/Components/Selectores/Simple';


export const SelectorEstadosPeriodo = (props:any) =>{

  let {data, onChange, valueOfSelected} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    //if(data)
    {setOptions(getOptions())}
  },[])

  useEffect(()=>{
    if(valueOfSelected===undefined && options!==undefined){ change(options[0]&&options[0].value)}
  },[options&&options.length])

  const STATE = {
    sinIniciar: (<EuiHealth color="warning" style={{ lineHeight: 'inherit' }}>Sin Iniciar</EuiHealth>),
    abierto:(<EuiHealth color="success" style={{ lineHeight: 'inherit' }}>Abierto</EuiHealth>),
    cerrado:(<EuiHealth color="danger" style={{ lineHeight: 'inherit' }}>Cerrado</EuiHealth>)
  }
 
  const getOptions = () =>{
      return [
        { value: 'Sin Iniciar', inputDisplay: STATE.sinIniciar },
        { value: 'Abierto', inputDisplay: STATE.abierto },
        { value: 'Cerrado', inputDisplay: STATE.cerrado }
      ]
    //return data.map((v: Vehiculo)=> { return { value: v.vehiculo, inputDisplay: v.vehiculo } })
  }

  const change = (value:any) =>{
    onChange(value)
  }

  return (
    <SelectorSimple {...props} options={options} onChange={change} name="selectEstadosPeriodo"/>
  )
}
export default SelectorEstadosPeriodo